exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#app[data-v-7e4ce899]{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;margin-top:60px;position:relative}.grid[data-v-7e4ce899]{display:grid;grid-template-columns:1fr}@media (min-width:800px){.grid[data-v-7e4ce899]{grid-template-columns:1.5fr 1fr}}.hotspots[data-v-7e4ce899]{padding-bottom:100%;position:relative;background-size:cover}.spot1[data-v-7e4ce899]{top:19%;left:35%}.spot2[data-v-7e4ce899]{top:51%;left:64%}.spot3[data-v-7e4ce899]{top:15%;left:50%}.spot4[data-v-7e4ce899]{top:30%;left:35%}.spot5[data-v-7e4ce899]{top:48%;left:35%}.spot6[data-v-7e4ce899]{top:76%;left:80%}.spot7[data-v-7e4ce899]{top:91%;left:60%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7e4ce899","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/vue/HotSpots.vue
// module id = 35
// module chunks = 0